import React from "react";
const ErrorPage = () => {
  return (
    <div className="error-page">
      <h1 className="error-page__title">Error Page Not Found </h1>
      <p className="error-page__message">
        Oops! Something went wrong. Please check the URL and try again.
      </p>
      <p className="error_link">
        <a href="/">
          Click on this <span>https://goto/homepage/feed/saurabh.com </span>
        </a>
        <h3>
          Internal Server Error: We're sorry, but our server encountered{" "}
          <br></br>an unexpected condition. Please try again later.
        </h3>
      </p>
    </div>
  );
};

export default ErrorPage;
